import {
  GET_NOTIFICATION_PENDING,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_ERROR,
  POST_NOTIFICATION_PENDING,
  POST_NOTIFICATION_SUCCESS,
  POST_NOTIFICATION_ERROR,
  PUT_NOTIFICATION_PENDING,
  PUT_NOTIFICATION_SUCCESS,
  PUT_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_PENDING,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_ERROR,
  NOTIFICATION_DATA,
  SET_NOTIFICATION_MODAL,
} from "../../actions/notification";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_NOTIFICATION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_NOTIFICATION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        pending: false,
      };
    case POST_NOTIFICATION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_NOTIFICATION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        pending: false,
      };
    case PUT_NOTIFICATION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_NOTIFICATION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        pending: false,
      };
    case DELETE_NOTIFICATION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case NOTIFICATION_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_NOTIFICATION_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default notification;
